// apps/web/src/features/dashboards/china-requests/PeriodSelector.tsx (#1589)
// Period preset <Select> + the custom from/to native date inputs (shown
// only for the `custom` preset). Drives all dashboard data.
import type { CSSProperties } from 'react';
import type { ChinaRequestsPeriodKey } from '@magimp/shared';
import { Select } from '../../../ui/index.js';
import type { UsePeriodQueryResult } from './usePeriodQuery.js';
import { CARD_GAP, type DashboardT } from './section.js';

interface PeriodSelectorProps {
  state: UsePeriodQueryResult;
  t: DashboardT;
}

const PRESET_ORDER: ChinaRequestsPeriodKey[] = ['today', 'last7d', 'month', 'quarter', 'custom'];

const DATE_INPUT_STYLE: CSSProperties = {
  height: 'var(--control-h)',
  padding: '0 10px',
  borderRadius: 'var(--r-2)',
  border: '1px solid var(--border-1)',
  background: 'var(--bg-1)',
  color: 'var(--fg-1)',
  fontFamily: 'var(--font-ui)',
  fontSize: 13,
};

export function PeriodSelector({ state, t }: PeriodSelectorProps) {
  const options = PRESET_ORDER.map((key) => ({
    value: key,
    label: t(`dashboards:chinaRequests.periods.${key}`),
  }));

  return (
    <div style={{ display: 'flex', gap: CARD_GAP, alignItems: 'center', flexWrap: 'wrap' }}>
      <label htmlFor="china-requests-period" style={{ fontSize: 13, color: 'var(--fg-2)' }}>
        {t('dashboards:chinaRequests.periodLabel')}
      </label>
      <Select
        value={state.period}
        onChange={(v) => state.setPeriod(v as ChinaRequestsPeriodKey)}
        options={options}
      />
      {state.period === 'custom' ? (
        <>
          <label style={{ fontSize: 13, color: 'var(--fg-2)' }}>
            {t('dashboards:chinaRequests.customFrom')}
            <input
              type="date"
              value={state.customFrom}
              max={state.customTo || undefined}
              onChange={(e) => state.setCustomFrom(e.target.value)}
              style={{ ...DATE_INPUT_STYLE, marginLeft: 6 }}
            />
          </label>
          <label style={{ fontSize: 13, color: 'var(--fg-2)' }}>
            {t('dashboards:chinaRequests.customTo')}
            <input
              type="date"
              value={state.customTo}
              min={state.customFrom || undefined}
              onChange={(e) => state.setCustomTo(e.target.value)}
              style={{ ...DATE_INPUT_STYLE, marginLeft: 6 }}
            />
          </label>
        </>
      ) : null}
    </div>
  );
}
